<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12")
            BaseTextField(rules="required" v-model="form.name", :label="translations.form.name", :disabled="!isActiveWhen(['pending','new'])")
        v-row(v-if="!isActiveWhen(['pending','new'])")
          v-col(cols="12")
            p {{ translations.form.dateInfo }}
        v-row
          v-col(cols="12" sm="6" md="4")
            BaseDatePicker(rules="required" v-model="form.startdate.date", :label="translations.form.startdate.date", :disabled="!isActiveWhen(['pending','new'])")
          v-col(cols="12" sm="6" md="4")
            BaseTimePicker(rules="required" v-model="form.startdate.time", :label="translations.form.startdate.time", :disabled="!isActiveWhen(['pending','new'])")
        v-row
          v-col(cols="12" sm="6" md="4")
            BaseDatePicker(rules="required" v-model="form.enddate.date", :label="translations.form.enddate.date", :disabled="!isActiveWhen(['pending','new','open'])")
          v-col(cols="12" sm="6" md="4")
            BaseTimePicker(rules="required" v-model="form.enddate.time", :label="translations.form.enddate.time", :disabled="!isActiveWhen(['pending','new','open'])")
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid"
              color="primary"
              type="submit"
              :loading="loadingEdit") {{ translations.buttons.edit }}

</template>

<script>

  export default {
    name: "MatchsetEdit",
    props: {
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      matchset: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() => ({
      form: {
        name: '',
        startdate: {
          date: null,
          time: null,
        },
        enddate: {
          date: null,
          time: null,
        },
      },
    }),
    computed: {
      loadingEdit() {
        return this.$store.state.statusCode.editMatchset.loading;
      },
      stateEdit() {
        return this.$store.state.statusCode.editMatchset.state;
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.setFields();
          this.$refs.validator.reset();
        }
      },
      stateEdit: function(val){
        if (val == 200) {
          this.$emit('successEdit');
        }
      },
    },
    created(){
      this.setFields();
    },
    methods:{
      submitDataForm(){
        const formSend = {
          _id: this.matchset._id,
          data: {
            name: this.form.name,
            start: this.getISOString(this.form.startdate),
            end: this.getISOString(this.form.enddate),
          }
        };
        this.$store.dispatch('editMatchset', formSend);
      },
      setFields(){
        const [startdate, starttime] = this.matchset.startdate.split(' ');
        const [enddate, endtime] = this.matchset.enddate.split(' ');
        this.form.name = this.matchset.name;
        this.form.startdate.date = startdate;
        this.form.startdate.time = starttime;
        this.form.enddate.date = enddate;
        this.form.enddate.time = endtime;
      },
      getISOString(dateObj){
        let [day, month, year] = dateObj.date.split('/');
        month = month - 1;
        month = (month + '').length == 1 ? '0'+ month : month;
        return `${year}-${month}-${day}T${dateObj.time}:00:000Z`;
      },
      isActiveWhen(status){
        // return !(this.matchset.status.value == 'new' || this.matchset.status.value == 'pending' || this.matchset.status.value == 'open');
        return status.includes(this.matchset.status.value);
      },
    }
  }
</script>

<style lang="sass">
</style>